import React, { Component } from 'react';
import { $ } from 'rype-bootstrap';
import ModalDecorator from 'hocs/ModalDecorator';

import ModalButton from '../../ModalButton/ModalButton';
import { RadioGroup, Radio } from '../../../Radio';
import '../style.css';

class DeleteMembershipStep1Modal extends Component {
  constructor() {
    super();

    $.noConflict();

    this.state = {
      selectedOption: 0
    };
  }

  componentDidMount() {
    // the HOC ModalDecorator adds and removes this modal from the DOM.
    //
    // once the component mounts, we need to manually add call show
    // to force Bootstrap to render the modal
    //
    // the delay is present to smooth the transitions
    // while the component continues to load
    setTimeout(() => $('#delete-ms-step1-modal').modal('show'), 75);

    // set up an event listener to call this.props.closeModal
    // whenever the modal is hidden.
    // closeModal comes from ModalDecorator, and causes
    // the element to be removed from the DOM
    $('#delete-ms-step1-modal').on('hidden.bs.modal', () => {
      this.props.closeModal();
    });
  }

  close = () => {
    // Call 'hide' to reset all the Bootstrap styling
    $('#delete-ms-step1-modal').modal('hide');
  }

  handleChange = (value) => {
    this.setState({ selectedOption: value });
  }

  render() {
    return (
      <div
        id="delete-ms-step1-modal"
        className="DeleteMembershipModal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="delete-membership-label"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <h5>Pause or delete account</h5>
              <div className="radio-group">
                <RadioGroup
                  name="pause-membership"
                  selectedValue={this.state.selectedOption}
                  onChange={this.handleChange}
                >
                  <Radio
                    value={1}
                    className="radio-item"
                    label="Temporarily pause my account for a month"
                  />
                  <p className="small-tip radio-desc">
                    Book lessons will be disabled when your account is paused.
                    <br />
                    Your plan will resume on April 8, 2017
                  </p>
                  <Radio
                    value={2}
                    className="radio-item"
                    label="Switch to the month-to-month plan at the end of my term"
                  />
                  <p className="small-tip radio-desc">
                    Account will be on a month-to-month plan at $149/mo on November 17, 2017, when
                    my existing commitment ends
                  </p>
                  <Radio
                    value={3}
                    className="radio-item"
                    label="Permanently delete this account at the end of my term"
                  />
                  <p className="small-tip radio-desc">
                    Account will be deleted on November 17, 2017, when my existing commitment ends
                  </p>
                </RadioGroup>
              </div>
              <ModalButton
                className="btn btn-primary mt-4"
                modalId="delete-ms-step2-modal"
                disabled={this.state.selectedOption === 0}
              >
                Next
              </ModalButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModalDecorator('delete-ms-step1-modal')(DeleteMembershipStep1Modal);



// WEBPACK FOOTER //
// ./src/components/modals/DeleteMembershipModals/Step1/index.js